import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CounterComponent } from './components/counter/counter.component';
import { createCustomElement } from '@angular/elements';

@NgModule({
  declarations: [
    CounterComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [CounterComponent]
})
export class CounterModule {
  constructor(injector: Injector) {
    const CounterElement = createCustomElement(CounterComponent, { injector });

    try {
      customElements.define('paybee-counter-element', CounterElement);
    } catch(e) {}
  }
}
